import { apiAxios } from '../config/axios';

export const ReferralService = {
  async getTotalReferral() {
    const res = await apiAxios.get('/referral/progress/count');
    return res.data;
  },
};
